<template>
  <v-navigation-drawer elevation="0" rail width="80" class="border-none bg-creative-dark" id="sidebar-modern">
    <!-- Logo Area -->
    <div class="logo-header d-flex justify-center align-center mb-2">
      <!-- Logo Container con efecto Glass sutil -->
      <div class="logo-box d-flex justify-center align-center">
         <v-img :src="require('@/assets/cetemin-logo.png')" width="36" height="36" contain></v-img>
      </div>
    </div>

    <!-- Navigation Items -->
    <v-list nav density="compact" class="px-0 d-flex flex-column align-center gap-3 w-100">

      <v-tooltip text="Dashboard" location="end" content-class="custom-tooltip">
        <template v-slot:activator="{ props }">
          <div class="nav-item-wrapper">
            <v-list-item v-bind="props" :to="{ name: 'Dashboard' }" class="nav-item" active-class="nav-active"
              v-if="$abillity.can('read', 'panel-metricas')">
                <div class="d-flex flex-column align-center justify-center w-100 h-100">
                  <v-icon size="20" class="mb-1 transition-colors">fa:fa-solid fa-gauge</v-icon>
                  <span class="nav-text">Dash</span>
                </div>
            </v-list-item>
          </div>
        </template>
      </v-tooltip>

      <v-tooltip text="Mi perfil" location="end" content-class="custom-tooltip">
        <template v-slot:activator="{ props }">
          <div class="nav-item-wrapper">
            <v-list-item v-bind="props" :to="{ name: 'profileUser' }" class="nav-item" active-class="nav-active">
                <div class="d-flex flex-column align-center justify-center w-100 h-100">
                  <v-icon size="20" class="mb-1 transition-colors">fa:fa-solid fa-user</v-icon>
                  <span class="nav-text">Perfil</span>
                </div>
            </v-list-item>
          </div>
        </template>
      </v-tooltip>

      <v-tooltip text="Tickets" location="end" content-class="custom-tooltip">
        <template v-slot:activator="{ props }">
          <div class="nav-item-wrapper">
            <v-list-item v-bind="props" :to="{ name: 'tickets' }" class="nav-item" active-class="nav-active"
              v-if="$abillity.can('read', 'tickets-area')">
                <div class="d-flex flex-column align-center justify-center w-100 h-100">
                  <v-icon size="20" class="mb-1 transition-colors">fa:fa-solid fa-ticket</v-icon>
                  <span class="nav-text">Tickets</span>
                </div>
            </v-list-item>
          </div>
        </template>
      </v-tooltip>

      <v-tooltip text="Gestionar Usuarios" location="end" content-class="custom-tooltip">
        <template v-slot:activator="{ props }">
          <div class="nav-item-wrapper">
            <v-list-item v-bind="props" :to="{ name: 'usuarios' }" class="nav-item" active-class="nav-active"
              v-if="$abillity.can('read', 'usuarios-area')">
                <div class="d-flex flex-column align-center justify-center w-100 h-100">
                  <v-icon size="20" class="mb-1 transition-colors">fa:fa-solid fa-users-gear</v-icon>
                  <span class="nav-text">Usuarios</span>
                </div>
            </v-list-item>
          </div>
        </template>
      </v-tooltip>

      <div class="mt-auto w-100 d-flex justify-center mb-4">
        <v-tooltip text="Configuración" location="end" content-class="custom-tooltip">
          <template v-slot:activator="{ props }">
            <div class="nav-item-wrapper">
              <v-list-item v-bind="props" :to="{ name: 'configuracion' }" class="nav-item" active-class="nav-active"
                v-if="$abillity.can('read', 'configuracion-area')">
                  <div class="d-flex flex-column align-center justify-center w-100 h-100">
                    <v-icon size="20" class="mb-1 transition-colors">fa:fa-solid fa-gear</v-icon>
                    <span class="nav-text">Config</span>
                  </div>
              </v-list-item>
            </div>
          </template>
        </v-tooltip>
      </div>

    </v-list>
  </v-navigation-drawer>
</template> 

<style scoped>
/* Fondo "Midnight Studio" */
.bg-creative-dark {
  background-color: #13111C !important; /* Muy oscuro, casi negro con tinte violeta */
}

/* Header */
.logo-header {
  width: 100%;
  height: 80px;
  background: linear-gradient(180deg, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0) 100%);
}

.logo-box {
  width: 44px;
  height: 44px;
  /* Glass effect sutil */
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.nav-item-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

/* Items Base */
.nav-item {
  width: 64px !important;
  height: 64px !important;
  min-height: 64px !important;
  border-radius: 16px !important; /* Más redondeado = más moderno */
  color: #9CA3AF !important; /* Gris neutro */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  margin: 0 !important;
  padding: 0 !important;
}

.nav-item:hover {
  background-color: rgba(255, 255, 255, 0.08);
  color: white !important;
  transform: scale(1.05);
}

.nav-text {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.8;
  margin-top: 4px;
}

/* --- ESTADO ACTIVO VIBRANTE --- */
.nav-active {
  /* Fondo degradado muy sutil */
  background: linear-gradient(135deg, rgba(236, 72, 153, 0.15) 0%, rgba(139, 92, 246, 0.05) 100%) !important;
  color: white !important;
  box-shadow: 0 0 20px rgba(236, 72, 153, 0.15); /* Glow rosado suave */
}

/* El Icono y Texto toman el color del gradiente de marca */
.nav-active .v-icon {
  color: #F472B6 !important; /* Pink 400 */
  filter: drop-shadow(0 0 5px rgba(244, 114, 182, 0.5)); /* Glow en el icono */
}

.nav-active .nav-text {
  color: #E9D5FF !important; /* Purple 200 */
  opacity: 1;
}

/* Indicador lateral Gradiente */
.nav-active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 28px;
  /* Gradiente Marketing: Rosa -> Violeta */
  background: linear-gradient(180deg, #EC4899 0%, #8B5CF6 100%);
  border-radius: 0 4px 4px 0;
  box-shadow: 2px 0 10px rgba(236, 72, 153, 0.6);
}

.gap-3 {
  gap: 16px;
}

.transition-colors {
  transition: color 0.3s ease;
}
</style>

<style>
.custom-tooltip {
  background-color: #1F2937 !important;
  color: #F3F4F6 !important;
  font-weight: 600;
  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 4px 6px rgba(0,0,0,0.3);
}
</style>